module.exports = __webpack_public_path__ + "static/media/qrdir.efe27646.png";